var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5",attrs:{"id":"page-events"}},[_c('h4',{staticClass:"mb-4 mt-4 ml-2"},[_vm._v("Evenemang för "+_vm._s(_vm.company.name))]),_c('EventList',{attrs:{"company":_vm.company,"events":_vm.events},on:{"select_event_clicked":_vm.select_event_clicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }